"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMMIGRATION_DACA = exports.BANKRUPTCY_CHAPTER_7 = exports.AJM_NY_DEBT_LAWSUIT = void 0; // AJM

exports.AJM_NY_DEBT_LAWSUIT = "ajmNyDebtLawsuit"; // Bankruptcy

exports.BANKRUPTCY_CHAPTER_7 = "bankruptcyChapter7"; // Immigration

exports.IMMIGRATION_DACA = "immigrationDaca";